export const AI_STATISTICS_FEATURES = [
  "Rimuovi sfondo",
  "Sfoca Sfondo",
  "Miglioramento Foto",
  "Espandi scena",
  "Fusione Sfondo",
  "Sorriso",
  "Pennello Correttivo",
  "Cambia abito",
  "Colora",
  "Correggi Colore",
  "Correggi Postura",
  "Rimuovi Oggetti",
  "Fotoritocco Intelligente",
];

const normalizeFeatureKey = (feature) =>
  String(feature || "")
    .trim()
    .toLocaleLowerCase("it-IT")
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ");

const FEATURE_ALIASES = {
  "fusione sfondo": "Fusione Sfondo",
  "background fusion": "Fusione Sfondo",
  "correggi postura": "Correggi Postura",
  "correct posture": "Correggi Postura",
  "rimuovi oggetto": "Rimuovi Oggetti",
  "rimuovi oggetti": "Rimuovi Oggetti",
  "rimuovi oggetti davanti": "Rimuovi Oggetti",
  "rimuovi oggetti davanti al soggetto": "Rimuovi Oggetti",
  "rimuovi gli oggetti davanti al soggetto": "Rimuovi Oggetti",
  "remove object in front of subject": "Rimuovi Oggetti",
  "remove object in front of subject accurate": "Rimuovi Oggetti",
  "remove the object in front of the subject": "Rimuovi Oggetti",
};

export const normalizeAiStatisticsFeature = (feature) => {
  const normalizedKey = normalizeFeatureKey(feature);
  return FEATURE_ALIASES[normalizedKey] || String(feature || "").trim();
};
